module.exports = __webpack_public_path__ + "static/media/sentences2.9ef8fece.png";